document.addEventListener("DOMContentLoaded", () => {
  initProductSwatches();

  const observer = new MutationObserver(() => {
    initProductSwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

function initProductSwatches() {
  const sliders = document.querySelectorAll(".psw--slider");

  sliders.forEach((slider) => {
    if (slider.dataset.swatchesInitialized) return;

    slider.dataset.swatchesInitialized = "true";
    initSlider(slider);
  });
}

function initSlider(slider) {
  const viewport = slider.querySelector(".psw__viewport");
  const container = slider.querySelector(".psw__container");

  if (!viewport || !container) return;

  const embla = EmblaCarousel(
    viewport,
    {
      align: "start",
      containScroll: "trimSnaps",
      dragFree: true,
      loop: false,
    },
    [EmblaCarouselWheelGestures()]
  );

  const updateAlignment = () => {
    const isOverflowing = container.scrollWidth > viewport.clientWidth;

    container.style.justifyContent = isOverflowing
      ? "flex-start"
      : "center";

    embla.reInit();
  };

  updateAlignment();
  window.addEventListener("resize", updateAlignment);

  const swatches = slider.querySelectorAll(".psw__item");

  function updateProductImage(card, swatch) {
    const image = card.querySelector(".card-media img");

    if (!image) return;

    const newImage = swatch.dataset.image;

    image.src = newImage;
    image.srcset = "";
  }

  function updateProductLinks(card, swatch) {
    const url = swatch.dataset.url;

    card.querySelectorAll("a").forEach((link) => {
      if (
        link.classList.contains("card-link") ||
        link.classList.contains("card-title")
      ) {
        link.href = url;
      }
    });
  }

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      swatches.forEach((item) => item.classList.remove("is-active"));
      swatch.classList.add("is-active");

      const card = slider.closest(".product-item");

      if (!card) return;

      updateProductImage(card, swatch);
      updateProductLinks(card, swatch);
    });
  });
}